import { render, staticRenderFns } from "./gudbrandsdal.vue?vue&type=template&id=a5948244&scoped=true&"
var script = {}
import style0 from "./gudbrandsdal.vue?vue&type=style&index=0&id=a5948244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5948244",
  null
  
)

export default component.exports